export default "__VITE_ASSET__CMe$sGyc__"